import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../codesList/actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import store from '../../../store';

function* deactivateCode({ payload: { id, type, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.codes.deactivate, id });

    dispatch(listActions.getCodesRequest({ type, curr_page: getState().getCodes.curr_page, filters: getState().getCodes.filters }));

    onSuccess && onSuccess();
    yield put(actions.deactivateCodeDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deactivateCodeFailed,
      endpoint: api.codes.deactivate.url
    });
  }
}

export const deactivateCodeSaga = takeEvery(types.DEACTIVATE_CODE_REQUEST, deactivateCode);